// extracted by mini-css-extract-plugin
module.exports =  {"isNotCompliantBtn":"isNotCompliantBtn__ndomj"};